import styled from 'styled-components';
import { KreoColors } from 'common/enums/kreo-colors';

const HEADER_HEIGHT = 90;

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.color.background};

  *::-webkit-scrollbar-thumb {
    background: ${p => p.theme.color.turquoiseFontDay};
  }

  *::-webkit-scrollbar-thumb:hover {
    background: ${p => p.theme.color.gray};
  }
`;

const Header = styled.div`
  height: ${HEADER_HEIGHT}px;
`;

const Main = styled.div`
  box-sizing: border-box;
  overflow: overlay;
  height: calc(100% - ${HEADER_HEIGHT}px);
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
`;

const Message = styled.div`
  box-sizing: border-box;
  width: 720px;
  margin: auto;
  padding: 50px;
  border-radius: 40px;
  background-color: ${props => props.theme.color.backgroundRush};

  > div {
    justify-content: center;
    padding-top: 20px;
  }

  > p {
    margin: 0 80px;
    text-align: center;
  }

  > button {
    margin: 0 auto;
    margin-top: 60px;
  }
`;

const ReviewCard = styled.div`
  width: 570px;
  box-sizing: border-box;
  padding: 30px;
  border-radius: 40px;
  margin: auto;
  background-color: ${props => props.theme.color.backgroundRush};
`;

const ErrorMessage = styled.p`
  padding-left: 115px;
  p {
    color: ${KreoColors.red};
  }
`;

const NoteContainer = styled.div`
  padding-bottom: 25px;

  & > p {
    text-align: center;
  }
`;

export const Styled = {
  Container,
  Header,
  Main,
  Message,
  ReviewCard,
  ErrorMessage,
  NoteContainer,
};
